module.exports = __webpack_public_path__ + "static/img/SN.8a5a3803.png";